export const checkPermission = (permissions, group, permission = []) => {
    let permissionArray = Array.isArray(permission) ? permission : [permission];
    let groupRules = permissions[group];
    let found = false;

    permissionArray.map((perm) => {
        if (groupRules[perm] && !!groupRules[perm]) {
            found = true;
        }
    })

    return found;
};

export const checkModule = (modules, name) => {
    return modules[name] && modules[name].enabled;
};

export const checkModuleGroup = (modules, type) => {
    return Object.keys(modules).filter(module => modules[module].type === type).some(module => modules[module].enabled);
};

